// import { Component } from "react";
// import { connect } from "react-redux";
// import PropTypes from "prop-types";

// import isEqual from "lodash/isEqual";
// import debounce from "lodash/debounce";

// import { getCompany, getSubcompany } from "auth/selectors";
// import {
//   getHistoricsReportPagination,
//   getHistoricsReportFilters,
//   getHistoricsReportNeedFetch
// } from "reports/selectors";

// import {
//   getHistoricsReport,
//   setHistoricsReportPagination as setPagination,
//   setHistoricsReportFilters as setFilters,
//   resetHistoricsReport as reset
// } from "reports/actions";

// import { valueFromEvent } from "lib/util";

// class HistoricsReportHandlers extends Component {
//   static propTypes = {
//     render: PropTypes.func.isRequired
//   };

//   fetch = (filters, pagination) => {
//     console.log(pagination.limit, pagination.page, pagination.orderBy, pagination.order);
//     this.props.fetch(
//       this.props.company.id,
//       this.props.subcompany.id,
//       filters,
//       pagination.limit,
//       pagination.page,
//       pagination.orderBy,
//       pagination.order
//     );
//   };

//   fetchDebounced = debounce(this.fetch, 300);

//   handleFiltersChange = e => this.props.setFilters(valueFromEvent(e));

//   handleFiltersSubmit = () => this.fetch(this.props.pagination, this.props.filters);

//   handleLimitChange = limit => this.props.setPagination({ limit: parseInt(limit, 10) });

//   handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

//   handlePageChange = page => this.props.setPagination({ page: parseInt(page, 10) });

//   componentWillMount = () => this.fetch(this.props.filters, this.props.pagination);

//   componentWillReceiveProps = nextProps => {
//     if (nextProps.needFetch && !isEqual(nextProps.pagination, this.props.pagination)) {
//       this.fetch(nextProps.filters, nextProps.pagination);
//     } else if (nextProps.needFetch && !isEqual(nextProps.filters, this.props.filters)) {
//       this.fetchDebounced(nextProps.filters, nextProps.pagination);
//     }
//   };

//   render = () =>
//     this.props.render({
//       handleFiltersChange: this.handleFiltersChange,
//       handleFiltersSubmit: this.handleFiltersSubmit,
//       handleLimitChange: this.handleLimitChange,
//       handleOrderChange: this.handleOrderChange,
//       handlePageChange: this.handlePageChange
//     });
// }

// const mapStateToProps = state => ({
//   company: getCompany(state),
//   subcompany: getSubcompany(state),
//   pagination: getHistoricsReportPagination(state),
//   filters: getHistoricsReportFilters(state),
//   needFetch: getHistoricsReportNeedFetch(state)
// });

// const mapDispatchToProps = { fetch: getHistoricsReport, setPagination, setFilters, reset };

// export default connect(mapStateToProps, mapDispatchToProps)(HistoricsReportHandlers);

import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';

import { getCompany, getSubcompany } from 'auth/selectors';
import {
  getVisibleAccountsParent,
  getVisibleCostCenters,
  getVisibleEmployees,
  getVisibleStatus,
} from 'selectors/lists';

import {
  getHistoricsReportPagination,
  getHistoricsReportFilters,
  getHistoricsReportNeedFetch,
} from 'reports/selectors';

import {
  getHistoricsReport,
  getHistoricsReportCSV,
  getHistoricsReportXLSX,
  getHistoricsReportPDF,
  resetHistoricsReport,
  setHistoricsReportFilters,
  setHistoricsReportPagination,
} from 'reports/actions';

import { valueFromEvent, saveAsCSV } from 'lib/util';
import { getLocations } from 'selectors/lists';
import { generateHistoricsPDF } from 'lib/pdfs/HistoricsPDF';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import FileSaver from 'file-saver';
import moment from 'moment';

class HistoricsReportHandlers extends PureComponent {
  static proptypes = {
    company: PropTypes.object.isEqual,
    subcompany: PropTypes.object.isEqual,
    filters: PropTypes.shape({
      fulltext: PropTypes.string.isRequired,
      depreciationType: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
    }).isRequired,
    needFetch: PropTypes.bool.isRequired,
    pagination: PropTypes.shape({
      page: PropTypes.number.isRequired,
      limit: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
      orderBy: PropTypes.string.isRequired,
      order: PropTypes.string.isRequired,
    }).isRequired,
    render: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };
  state = {
    exactSearch: false,
    columnSearch: [
      // Cambiar por redux
      { separator: this.props.t('reports.searchEditor.assets') },
      {
        key: 'asset.indexInteger.indexString',
        name: this.props.t('reports.searchEditor.id'),
        search: true,
      },
      { key: 'asset.number', name: this.props.t('reports.searchEditor.number'), search: true },
      { key: 'asset.name', name: this.props.t('reports.searchEditor.name'), search: true },
      {
        key: 'asset.description',
        name: this.props.t('reports.searchEditor.description'),
        search: true,
      },
      {
        key: 'asset._account.name',
        name: this.props.t('reports.searchEditor.accountType'),
        search: true,
      },
      {
        key: 'asset._subaccount.name',
        name: this.props.t('reports.searchEditor.assetType'),
        search: true,
      },
      {
        key: 'asset._costCenter.name',
        name: this.props.t('reports.searchEditor.centerCost'),
        search: true,
      },
      {
        key: 'asset._employee.name',
        name: this.props.t('reports.searchEditor.nameEmployee'),
        search: true,
      },
      {
        key: 'asset._employee.lastname',
        name: this.props.t('reports.searchEditor.lastNameEmployee'),
        search: true,
      },
      {
        key: 'asset._provider.name',
        name: this.props.t('reports.searchEditor.provider'),
        search: true,
      },
      { separator: this.props.t('reports.oldSearchEditor.oldValues') },
      {
        key: 'changes.indexInteger.indexString',
        name: this.props.t('reports.oldSearchEditor.id'),
        search: true,
      },
      { key: 'changes.number', name: this.props.t('reports.oldSearchEditor.number'), search: true },
      { key: 'changes.name', name: this.props.t('reports.oldSearchEditor.name'), search: true },
      {
        key: 'changes.description',
        name: this.props.t('reports.oldSearchEditor.description'),
        search: true,
      },
      {
        key: 'changes._account.name',
        name: this.props.t('reports.oldSearchEditor.contableAccount'),
        search: true,
      },
      {
        key: 'changes._subaccount.name',
        name: this.props.t('reports.oldSearchEditor.assetType'),
        search: true,
      },
      {
        key: 'changes._costCenter.name',
        name: this.props.t('reports.oldSearchEditor.centerCost'),
        search: true,
      },
      {
        key: 'changes._employee.name',
        name: this.props.t('reports.oldSearchEditor.nameEmployee'),
        search: true,
      },
      {
        key: 'changes._employee.lastname',
        name: this.props.t('reports.oldSearchEditor.lastNameEmployee'),
        search: true,
      },
      {
        key: 'changes._provider.name',
        name: this.props.t('reports.oldSearchEditor.provider'),
        search: true,
      },
      { separator: this.props.t('reports.changeSearchEditor.changes') },
      { key: 'campo', name: this.props.t('reports.changeSearchEditor.field'), search: true },
      { key: 'valor', name: this.props.t('reports.changeSearchEditor.value'), search: true },
    ],
  };

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.needFetch &&
      (!isEqual(nextProps.pagination, this.props.pagination) ||
        !isEqual(nextProps.filters, this.props.filters) ||
        !isEqual(nextProps.filters.fulltext, this.props.filters.fulltext) ||
        !isEqual(nextProps.filters.accounts, this.props.filters.accounts) ||
        !isEqual(nextProps.filters.costCenters, this.props.filters.costCenters) ||
        !isEqual(nextProps.filters.employees, this.props.filters.employees) ||
        !isEqual(nextProps.filters.status, this.props.filters.status) ||
        !isEqual(nextProps.filters.endDate, this.props.filters.endDate))
    ) {
      this.fetchDebounce(nextProps.pagination, nextProps.filters);
    }
  };

  componentWillMount = () => this.fetch(this.props.pagination, this.props.filters);
  componentWillUnmount = () => this.props.reset();

  fetch = (pagination, filters) => {
    const { company, subcompany } = this.props;

    this.props.getReport(
      company.id,
      subcompany.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );
  };

  fetchDebounce = debounce(this.fetch, 200);

  handleExport = () => {
    const { company, subcompany } = this.props;

    this.props
      .getReportCSV(company.id, subcompany.id, this.props.filters)
      .then(({ value: { data } }) => saveAsCSV(`historico`, this.props.filters.endDate, data))
      .catch((e) => {});
  };

  /**
   * @author Jorge Casas
   *
   * @function handleExportXLSX
   *
   * @description This function is used to get the historics report in XLSX format
   *
   * @param {object} e - Event object
   * @returns {void}
   */
  handleExportXLSX = (e) => {
    const { company, subcompany } = this.props;
    this.props
      .getReportXLSX(company.id, subcompany.id, this.props.filters)
      .then((response) => {
        if (
          response &&
          response.value &&
          response.value.data &&
          response.value.data.type === 'Buffer' &&
          Array.isArray(response.value.data.data) &&
          response.value.data.data.length > 0
        ) {
          const dataArray = new Uint8Array(response.value.data.data);
          const blob = new Blob([dataArray], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          FileSaver.saveAs(blob, `historico-${moment().format('DDMMYYYY')}.xlsx`);
        } else {
          console.error('The response does not contain valid data:', response);
        }
      })
      .catch((error) => {
        console.error('Error exporting XLSX:', error);
      });
  };

  handleExportPDF = (t) => {
    const { company, subcompany } = this.props;

    this.props
      .getReportPDF(company.id, subcompany.id, this.props.filters)
      // .then((data) => {
      //   console.log('%c ' + JSON.stringify(data), 'background: #222; color: #bada55');
      //   return data
      // })
      // .then(({ value: { data } }) => {
      .then((data) => {
        generateHistoricsPDF(
          this.props.company,
          data.value.records,
          this.props.filters,
          t,
          this.props.accounts,
          this.props.costCenters,
          this.props.employees,
          this.props.status,
          this.props.locations
        );
      })
      .catch((e) => console.log(e));
  };

  handleFiltersChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleFiltersSubmit = () => this.fetch(this.props.pagination, this.props.filters);

  handleLimitChange = (limit) => this.props.setPagination({ limit: parseInt(limit, 10) });

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handlePageChange = (page) => this.props.setPagination({ page: parseInt(page, 10) });

  handleExactSearch = () => {
    let exactSearch = this.state.exactSearch;
    this.props.setFilters({ exactSearch });
    this.setState({ exactSearch: !exactSearch });
  };

  handleToggleSearch = (col) => {
    let columnsNuevo = this.state.columnSearch;
    let datos = columnsNuevo.find((column) => column.key == col);
    datos.search = !datos.search;
    this.setState({ columnSearch: columnsNuevo });
    let columnsSearch = [];
    columnsNuevo.forEach((e) => {
      if (e.search) {
        columnsSearch.push(e.key);
      }
    });
    this.props.setFilters({ columnSearch: columnsSearch }); // Agregado a Redux
  };

  render = () =>
    this.props.render({
      handleExport: this.handleExport,
      handleExportXLSX: this.handleExportXLSX,
      handleExportPDF: this.handleExportPDF,
      handleFiltersChange: this.handleFiltersChange,
      handleFiltersSubmit: this.handleFiltersSubmit,
      handleLimitChange: this.handleLimitChange,
      handleOrderChange: this.handleOrderChange,
      handlePageChange: this.handlePageChange,
      handleToggleSearch: this.handleToggleSearch,
      handleExactSearch: this.handleExactSearch,
      columnSearch: this.state.columnSearch,
    });
}

const mapStateToProps = (state) => ({
  filters: getHistoricsReportFilters(state),
  pagination: getHistoricsReportPagination(state),
  needFetch: getHistoricsReportNeedFetch(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
  locations: getLocations(state),
  accounts: getVisibleAccountsParent(state),
  costCenters: getVisibleCostCenters(state),
  employees: getVisibleEmployees(state),
  status: getVisibleStatus(state),
});

const mapDispatchToProps = {
  getReport: getHistoricsReport,
  getReportCSV: getHistoricsReportCSV,
  getReportXLSX: getHistoricsReportXLSX,
  getReportPDF: getHistoricsReportPDF,
  reset: resetHistoricsReport,
  setFilters: setHistoricsReportFilters,
  setPagination: setHistoricsReportPagination,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(HistoricsReportHandlers);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/containers/HistoricsReportHandlers.js